(function(){
    'use strict'

    angular
    .module('app.inscripciones')
    .controller('inscripciones.EditPagoV2', EditPagoV2);

    EditPagoV2.$inject = ['$q', '$scope', '$animationsSrv', '$routeParams','ApiBaseService', 'logger', '$location', 'UserInfoService', 'moment'];

    function EditPagoV2($q, $scope, $animationsSrv, $routeParams, ApiBaseService, logger, $location, UserInfoService, moment) {
    
        $animationsSrv.scrollToTop();

        const MONEDA_COLONES = 1;
        const MONEDA_DOLARES = 2;

        const apiInscripciones = 'api/Inscripciones';

        let vm = this;

        vm.data = {
            inscripcionId: 0,
            eventoId: 0,
            depositoTipoId: 0,
            depositoIdentificacion: '',
            cuentaIban: '',
            sinpeTipoId: 0,
            sinpeIdentificacion: '',
            sinpeTelefono: '',
            nombreTarjeta: '',
            numeroTarjeta: '',
            cvv: '',
            mesExpiracion: 1,
            annoExpiracion: moment().year(),
            metodoPagoId: 0,
            precioDescuento: 0
        };

        vm.title = 'Datos de Pago';
        vm.id = $routeParams.id ? $routeParams.id : 0;

        vm.bancos = [];
        vm.eventos = [];
        vm.tiposDeposito = [];
        vm.paquetes = [];
        vm.tipoCambio = null;

        var permisosInscripciones = UserInfoService.getPermisosInscripciones();

        vm.uiData = {
            fechaDepositoOpened: false,
            puedeCambiarEstado: permisosInscripciones.modificar === true,
            descripcionRecibidoConfirmacion: 'Si he recibido la confirmacion',
            descripcionConfirmarPago: 'Confirmar Pago',
            descripcionContinuar: 'Continuar',
            esOrganizador: UserInfoService.esOrganizador(),
            depositoIdentificacionMsg: 'formato: 0#-####-#### (Ej: 01-1393-1919)',
            sinpeIdentificacionMsg: 'formato: 0#-####-#### (Ej: 01-1393-1919)',
            validationErrors: [],
            estaCreandoMetodoPago: true,
            estaConfirmandoPago: false,
            estaConfirmandoPagoRealizado: false,
            openFechaDeposito(){
                this.fechaDepositoOpened = !this.fechaDepositoOpened;
            }
        };

        var promiseBancos = getComboData(vm.bancos, 'api/Bancos', null, 'Error al cargar los bancos');
        var promiseEventos = getComboData(vm.eventos, 'api/Eventos/All', null, 'Error al cargar los eventos');
        var promiseTiposDeposito = getComboData(vm.tiposDeposito, 'api/TiposDeposito/online-metodos', null, 'Error al cargar los Tipos de Deposito');
        var promiseTipoCambio = getTipoCambio('api/indicadores/tipo-cambio-venta', null, 'Error al obtener el indicador');

        function getComboData(array, apiUrl, params, errorMessage){
            ApiBaseService.remoteController = apiUrl;
            var promise = ApiBaseService.getAll(params)
            .then(function(data){
                array.splice(0);
                array.push(...data);
            })
            .catch(function(error){
                $logger.error(errorMessage);
            }); 
            
            return promise;
        };

        function getTipoCambio(apiUrl, params, errorMessage){
            ApiBaseService.remoteController = apiUrl;
            var promise = ApiBaseService.getAll(params)
            .then(function(data){
                console.log(`tipo cambio: ${data.valor}`);
                vm.tipoCambio = data.valor;
            })
            .catch(function(error){
                $logger.error(errorMessage);
            }); 
            
            return promise;
        };

        get();

        function get(){

            $q.all([promiseBancos, promiseEventos, promiseTiposDeposito, promiseTipoCambio])
            .then(function(){

                if(vm.id != 0){
                    ApiBaseService.remoteController = apiInscripciones;
                    var promise = ApiBaseService.getAll([vm.id]);

                    promise
                    .then(function(data){
                        data.precio = getPrecioEvento(data.eventoId);
                        data.bancoId = data.bancoId == null ? 0 : data.bancoId;
                        data.metodoPagoId = data.metodoPagoId == null ? 0 : data.metodoPagoId;
                        data.fechaDeposito = data.fechaDeposito == null ? moment().toDate() : moment(data.fechaDeposito).toDate();
                        data.nombreDepositante = `${data.nombre} ${data.apellidos} ${data.apellido2}`;
                        
                        if(data.paqueteId == 0)
                        {
                            data.montoDeposito = data.montoDeposito == null ? getEvento(data.eventoId).precio : data.montoDeposito;
                        }
                        
                        vm.data = data;
                        vm.data.inscripcionId = data.id;
                        vm.data.depositoTipoId = 0;
                        vm.data.depositoIdentificacion = '';
                        vm.data.cuentaIban = '';
                        vm.data.sinpeTipoId = 0;
                        vm.data.sinpeIdentificacion = '';
                        vm.data.sinpeTelefono = '';
                        vm.data.nombreTarjeta = '';
                        vm.data.numeroTarjeta = '';
                        vm.data.cvv = '';
                        vm.data.mesExpiracion = 1;
                        vm.data.annoExpiracion = moment().year();

                        var promisePaquetes = getComboData(vm.paquetes, 'api/Paquetes/All-Activos-Evento', [data.eventoId], 'Error al cargar los paquetes');
                        promisePaquetes.then(function(){
                            if(data.paqueteId != 0)
                            {
                                vm.data.paqueteId = data.paqueteId;
                                const precioObj = getPrecioEventoConPaquete(data.eventoId, data.paqueteId, data.cupon);
                                vm.data.precio = precioObj.precioText;
                                vm.data.precioDescuento = precioObj.precioConDescuentoText;
                                vm.data.montoDeposito = data.montoDeposito == null ? precioObj.precio : data.montoDeposito;  
                                vm.data.precioSinpe = precioObj.precioSinpe;
                                vm.data.precioSinpeConDescuento = precioObj.precioSinpeConDescuento;                              
                            }
                        });
                    })
                    .catch(function(error){
                        switch (error.status) {
                            case 401:
                                logger.error('La sesión ha expirado');
                                break;
                        
                            default:
                                logger.error('Hubo un error al obtener el registro: ' + error.data.Message);
                                break;
                        }
                    });               
                }
            });
        };

        function getMonedaSymbol(monedaId)
        {
            switch (monedaId) {
                case MONEDA_COLONES:
                    return '₡';
                case MONEDA_DOLARES:
                    return '$';
                default:
                    return '';
            }
        };

        function getPrecioEvento(eventoId)
        {
            const evento = getEvento(eventoId);

            let monedaSymbol = getMonedaSymbol(evento.monedaId);

            return `${monedaSymbol} ${evento.precio}`;
        };

        function getPrecioEventoConPaquete(eventoId, paqueteId, cupon)
        {
            if(eventoId != 0 && paqueteId != 0)
            {
                const paquete = vm.paquetes.find((e)=>{return e.id == paqueteId;});
                const evento = getEvento(eventoId);

                let montoCupon = 0;
                let montoConDescuento = 0;

                if(cupon != null)
                {
                    montoCupon = cupon.monto;
                }

                if(paquete != null && evento != null)
                {
                    const monedaSymbol = getMonedaSymbol(evento.monedaId);
                    montoConDescuento = paquete.monto - montoCupon;

                    const tipoCambio = evento.monedaId === MONEDA_COLONES ? 1 :vm.tipoCambio;

                    return {
                        precioText: `${monedaSymbol} ${paquete.monto}`,
                        precioConDescuentoText: `${monedaSymbol} ${montoConDescuento >= 0 ? montoConDescuento : 0}`,
                        precio: montoConDescuento >= 0 ? montoConDescuento : 0,
                        precioSinpe: `₡ ${paquete.monto * tipoCambio}`,
                        precioSinpeConDescuento: `₡ ${montoConDescuento * tipoCambio}`
                    };
                }                
            }
            return null;
        };

        function getEvento(eventoId){
            return vm.eventos.find((evento) => {
                return evento.id == eventoId;
            });
        };

        function doFormValidations()
        {
            validateSelectProperty($scope.dataForm, vm.data, 'eventoId' );
            validateSelectProperty($scope.dataForm, vm.data, 'metodoPagoId' );
        };

        function setEstadoConfirmandoPago() {
            vm.uiData.estaCreandoMetodoPago = false;
            vm.uiData.estaConfirmandoPago = true;
        };

        function setEstadoConfirmandoPagoRealizado() {
            vm.uiData.estaCreandoMetodoPago = false;
            vm.uiData.estaConfirmandoPago = false;
            vm.uiData.estaConfirmandoPagoRealizado = true;
        };

        vm.getPrecioSinpe = function(){
            return vm.data.cuponId == null ? vm.data.precioSinpe : vm.data.precioSinpeConDescuento;
        };

        vm.saveMetodo = function(){

            vm.uiData.validationErrors.length = 0;

            $scope.submitted = true;

            doFormValidations();

            if($scope.dataForm.$valid){
                if(vm.data.id && $scope.dataForm.$dirty){
                    createMetodoPago();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }  
        };

        vm.confirmIntension = function(){

            vm.uiData.validationErrors.length = 0;

            if(vm.data.metodoPagoId === 2) {

                confirmIntensionPagoSinpe();

            } else if(vm.data.metodoPagoId === 5)  {

                confirmIntensionPagoTarjeta();

            }
            
        };

        vm.checkIntension = function(){

            vm.uiData.validationErrors.length = 0;

            checkIntensionPago();
        };

        function createMetodoPago(){
            ApiBaseService.remoteController = apiInscripciones + '/Pago-Crear-Metodo';
            var promise = ApiBaseService.update(vm.data);
            
            promise
            .then(function(response){
                //logger.success('presiona confirmar para finalizar el pago.');
                createIntensionPago();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                    case 400:
                        vm.uiData.validationErrors = error.data;
                        logger.error('Hubo un error al ingresar el metodo de pago');
                        break;
                    case 422:
                        vm.uiData.validationErrors = error.data.errorList;
                        logger.error('Hubo un error al ingresar el metodo de pago');
                        break;
                    default:
                        logger.error('Hubo un error al modificar el registro: ' + error.data.Message);
                        break;
                }
            });   
        };

        function createIntensionPago(){
            ApiBaseService.remoteController = apiInscripciones + '/Pago-v2-crear-intension';
            var promise = ApiBaseService.update(vm.data);
            
            promise
            .then(function(response){
                logger.success('Confirma el pago para continuar.');
                vm.data.intensionProveedorId = response.data.proveedorId;
                setEstadoConfirmandoPago();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                    case 400:
                        vm.uiData.validationErrors = error.data;
                        logger.error('Hubo un error al crear la intension de pago');
                        break;
                    case 422:
                        vm.uiData.validationErrors = error.data.errorList;
                        logger.error('Hubo un error al crear la intension de pago');
                        break;
                    default:
                        logger.error('Hubo un error al modificar el registro: ' + error.data.Message);
                        break;
                }
            });   
        };

        function confirmIntensionPagoSinpe(){
            ApiBaseService.remoteController = apiInscripciones + '/Pago-v2-confirmar-intension';
            var promise = ApiBaseService.update(vm.data);
            
            promise
            .then(function(response){
                logger.success('Confirmación de Pago realizada.');

                setEstadoConfirmandoPagoRealizado();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                    case 400:
                        vm.uiData.validationErrors = error.data;
                        logger.error('Hubo un error al crear la intension de pago');
                        break;
                    case 422:
                        vm.uiData.validationErrors = error.data.errorList;
                        logger.error('Hubo un error al crear la intension de pago');
                        break;
                    default:
                        logger.error('Hubo un error al modificar el registro: ' + error.data.Message);
                        break;
                }
            });   
        };

        function confirmIntensionPagoTarjeta(){
            ApiBaseService.remoteController = apiInscripciones + '/Pago-v2-confirmar-intension';
            var promise = ApiBaseService.update(vm.data);
            
            promise
            .then(function(response){
                logger.success('Pago Realizado.');

                if(vm.uiData.esOrganizador)
                {
                    $location.path('/editar-inscripcion');
                }
                else{
                    $location.path('/inscripciones');
                }
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                    case 400:
                        vm.uiData.validationErrors = error.data;
                        logger.error('Hubo un error al crear la intension de pago');
                        break;
                    case 422:
                        vm.uiData.validationErrors = error.data.errorList;
                        logger.error('Hubo un error al crear la intension de pago');
                        break;
                    default:
                        logger.error('Hubo un error al modificar el registro: ' + error.data.Message);
                        break;
                }
            });   
        };

        function checkIntensionPago(){
            logger.success('Pago Realizado.');

            if(vm.uiData.esOrganizador)
            {
                $location.path('/editar-inscripcion');
            }
            else{
                $location.path('/inscripciones');
            }
        };

        function validateSelectProperty(form, object, property){
            if(object[property] == 0){
                form[property].$setValidity("different", false);
                return false;
            }
            else{
                form[property].$setValidity("different", true);
                return true;
            }
        };

        vm.onSelectChanged = function(property){

            switch (property) {
                case "eventoId":
                    onEventoIdChanged(property);
                    break;
                case "metodoPagoId":
                    onTipoDepositoIdChanged(property);
                    break;
                case "sinpeTipoId":
                    onSinpeTipoIdChanged(property);
                    break;
                case "depositoTipoId":
                    onDepositoTipoIdChanged(property);
                    break;
                default:
                    break;
            }
        };

        function onEventoIdChanged(property)
        {
            var result = validateSelectProperty($scope.dataForm, vm.data, property );

            if(result)
            {
                vm.data.precio = getPrecioEvento(vm.data.eventoId);
            }
            else{
                vm.data.precio = '0';
            }
        };

        function onSinpeTipoIdChanged(property)
        {
            switch (vm.data.sinpeTipoId) {
                case 0:
                    vm.uiData.sinpeIdentificacionMsg = 'formato: 0#-####-#### (Ej: 01-1393-1919)';
                    break;
                case 1:
                    vm.uiData.sinpeIdentificacionMsg = 'formato: 1########### (Ej: 1293817461127)';
                    break;     
                case 2:
                    vm.uiData.sinpeIdentificacionMsg = 'formato: 2-###-###### (Ej: 2-100-000001)';
                    break;  
                case 3:
                    vm.uiData.sinpeIdentificacionMsg = 'formato: 3-###-###### (Ej: 3-101-212393)';
                    break;  
                case 4:
                    vm.uiData.sinpeIdentificacionMsg = 'formato: 4-000-###### (Ej: 4-000-042141)';
                    break;  
                case 5:
                    vm.uiData.sinpeIdentificacionMsg = 'formato: 5########### (Ej: 5123456789011)';
                    break;
                case 9:
                    vm.uiData.sinpeIdentificacionMsg = 'formato: 1########### (Ej: 1293817461127)';
                    break;      
                default:
                    vm.uiData.sinpeIdentificacionMsg = 'invalido!';
                    break;
            }
        };

        function onDepositoTipoIdChanged(property)
        {
            switch (vm.data.sinpeTipoId) {
                case 0:
                    vm.uiData.depositoIdentificacionMsg = 'formato: 0#-####-#### (Ej: 01-1393-1919)';
                    break;
                case 1:
                    vm.uiData.depositoIdentificacionMsg = 'formato: 1########### (Ej: 1293817461127)';
                    break;     
                case 2:
                    vm.uiData.depositoIdentificacionMsg = 'formato: 2-###-###### (Ej: 2-100-000001)';
                    break;  
                case 3:
                    vm.uiData.depositoIdentificacionMsg = 'formato: 3-###-###### (Ej: 3-101-212393)';
                    break;  
                case 4:
                    vm.uiData.depositoIdentificacionMsg = 'formato: 4-000-###### (Ej: 4-000-042141)';
                    break;  
                case 5:
                    vm.uiData.depositoIdentificacionMsg = 'formato: 5########### (Ej: 5123456789011)';
                    break;
                case 9:
                    vm.uiData.depositoIdentificacionMsg = 'formato: 1########### (Ej: 1293817461127)';
                    break;      
                default:
                    vm.uiData.sinpeIdentificacionMsg = 'invalido!';
                    break;
            }
        };

        function onTipoDepositoIdChanged(property)
        {
            validateSelectProperty($scope.dataForm, vm.data, property );
        };
    }
})();